import Intranet from "@/layouts/intranet/Index.vue";
import crudUpdate from "@/components/crud_ag/actions/Update";

export default {
  path: "/projects",
  component: Intranet,
  children: [
    {
      path: "",
      name: "projectsCrud",
      component: () => import("@/views/crud/ProyectoCrud.vue"),
      meta: {
        auth: true,
        title: "Projectes",
        serviceName: "proyectos",
      },
      children: [
        {
          path: ":id",
          name: "projectsCrudUpdate",
          component: crudUpdate,
          meta: {
            auth: true,
            title: "Projecte",
            serviceName: "proyectos",
          },
        },
      ],
    },
  ],
};
